/**
 * @returns function is returning a transformed version of the input object
 * `obj`. The function checks if the input is an object or an array, and then iterates over the keys of
 * the object to transform the values based on certain conditions. The transformed object is then
 * returned.
 */
export const convertStringValues = (obj: any): any => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(convertStringValues);
    }

    const transformedObj: any = {};
    for (const key in obj) {
        if (obj[key]) {
            const value = obj[key];

            if (value === 'true') {
                transformedObj[key] = true;
            } else if (value === 'false') {
                transformedObj[key] = false;
            } else if (!isNaN(Number(value)) && value.trim() !== '') {
                transformedObj[key] = Number(value);
            } else {
                transformedObj[key] = convertStringValues(value);
            }
        }
    }
    return transformedObj;
};

export const safeParseJSON = (jsonString: string) => {
    try {
        return JSON.parse(jsonString);
    } catch (error: any) {
        throw new Error(
            `Invalid JSON: ${jsonString}. Error: ${error?.message}`,
        );
    }
};
